import defaultStore from '../defaultStore'
import utils from '@/utils'

const { store } = defaultStore(`company`, utils.makeBackendRequestData)

export default {
  ...store,
}
